import { createReducer } from "@reduxjs/toolkit";
import constants from "./CONSTANTS";
import authConstants from "src/store/auth/CONSTANTS.js";

export const initState = {
  mainPageBanners: [],
  mainPageNewsAndBLogs: [],
  blogDetailedData: undefined,
  blogGlobalId: undefined,
  globalLoader: false,
};

const reducer = createReducer(initState, (builder) =>
  builder
    // reset whole state if layout send logout action
    .addCase(authConstants.RESET_ALL, () => initState)
    .addCase(authConstants.LOGOUT_USER, () => initState)

    .addCase(constants.SET_MAIN_PAGE_BANNERS, (state, action) => {
      state.mainPageBanners = action.payload;
    })
    .addCase(constants.SET_MAIN_PAGE_NEWS_AND_BLOGS, (state, action) => {
      state.mainPageNewsAndBLogs = action.payload;
    })
    .addCase(constants.SET_NEWS_AND_BLOGS_DETAILD_DATA, (state, action) => {
      state.blogDetailedData = action.payload;
    })
    .addCase(constants.SET_NEWS_AND_BLOGS_GLOBAL_ID, (state, action) => {
      state.blogGlobalId = action.payload;
    })
    .addCase(constants.SET_GLOBAL_PAGE_LOADER, (state, action) => {
      state.globalLoader = action.payload;
    })
);

export default reducer;
